import { render, staticRenderFns } from "./IndiceAndrogeniosLivres.vue?vue&type=template&id=7f758aee"
import script from "./IndiceAndrogeniosLivres.vue?vue&type=script&lang=js"
export * from "./IndiceAndrogeniosLivres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports